import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { CommunicationsPostActions } from 'src/app/_enums';

@Component({
  selector: 'app-post-actions',
  templateUrl: './post-actions.component.html',
  styleUrls: ['./post-actions.component.scss']
})
export class PostActionsComponent extends BaseComponent implements OnInit {
  @Input()
  thereIsActive: boolean = true;
  @Input()
  isActive: boolean = true;
  @Input()
  isDisabledEdit: boolean = false;
  @Output()
  postActionEmitter: EventEmitter<number> = new EventEmitter<number>();
  constructor() {
    super();
  }

  ngOnInit() {}
  edit(): void {
    this.postActionEmitter.emit(CommunicationsPostActions.Edit);
  }
  inactive(): void {
    this.postActionEmitter.emit(CommunicationsPostActions.Inactive);
  }
  active(): void {
    this.postActionEmitter.emit(CommunicationsPostActions.Active);
  }
  delete(): void {
    this.postActionEmitter.emit(CommunicationsPostActions.Delete);
  }
  getClasses(): string {
    return this.settings.rtl ? 'mat-menu-tia-2 rtl' : 'mat-menu-tia-2';
  }
}
